import type { Period } from "@/types";
import { useMemo } from "react";
import usePerfChartData from "./usePerfChartData";

export default function useAvailablePerformanceDates(
	shareClassId?: number,
	partId?: number,
	period?: Period,
) {
	const [performanceData] = usePerfChartData(
		shareClassId,
		partId,
		undefined,
		undefined,
		period,
	);

	const allAvailableDates = useMemo(() => {
		if (performanceData) {
			return performanceData.share_class_plots[0].data.map(
				([timestamp]) => new Date(timestamp),
			);
		}
		return [];
	}, [performanceData]);

	return allAvailableDates;
}
